import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import AuthGuard from './auth/AuthGuard';
import StatusPage from './pages/StatusPage';
import IncidentPage from './pages/IncidentPage';
import MaintenancePage from './pages/MaintenancePage';
import AdminLayout from './pages/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import ComponentsAdmin from './pages/admin/ComponentsAdmin';
import IncidentsAdmin from './pages/admin/IncidentsAdmin';
import MaintenancesAdmin from './pages/admin/MaintenancesAdmin';
import AvailabilityStats from './pages/AvailabilityStats';
import History from './pages/History';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<StatusPage />} />
        <Route path="incidents/:id" element={<IncidentPage />} />
        <Route path="maintenance/:id" element={<MaintenancePage />} />
        <Route path="availability" element={<AvailabilityStats />} />
        <Route path="history" element={<History />} />
      </Route>
      <Route
        path="/console"
        element={
          <AuthGuard>
            <AdminLayout />
          </AuthGuard>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="components" element={<ComponentsAdmin />} />
        <Route path="incidents" element={<IncidentsAdmin />} />
        <Route path="maintenances" element={<MaintenancesAdmin />} />
      </Route>
    </Routes>
  );
}

export default App;
